
export default {
  head() {
    return {
      link: [],
    };
  },
  methods: {
    subscribe() {
      this.$ga.event('Newsletter', 'Click', 'Subscribe');
    },
  },
};
